<template>
  <div class="dispatch-map-container">
    <div class="map-here" id="mapHere"></div>

    <a class="recenter" href="javascript:;" @click="setCenter">
      <i class="far fa-dot-circle fa-lg fa-fw"></i>
    </a>

    <a :class="['filter-toggle', {open: driverFilter.show,hide: rsvp === null || rsvp.driver !== null}]"
      href="javascript:;" @click="driverFilter.show = !driverFilter.show">
      <i :class="{
        'far fa-times-circle': driverFilter.show,
        'fas fa-sliders-h': !driverFilter.show,
        'fa-fw fa-lg': true
      }"></i>
    </a>

    <div :class="['driver-filters', {hide:!driverFilter.show || rsvp === null}]">
      <div :class="['cover', {show: driverFilter.isLoading || driverFilter.serviceLoading }]">
        <div class="cover-container">
          <div class="cover-content">
            <pulse-loader></pulse-loader>
            <div class="content">{{ $t('dispatch.map.filterControls.labelLoading') }}</div>
          </div>
        </div>
      </div>

      <div class="message">
        <span v-if="qualifiedDrivers.active">Use the form below to modify restrictions</span>
        <span v-else>{{ $t('dispatch.map.filterControls.title') }}</span>
      </div>

      <form class="extend-input" @submit.prevent="driverFilterSubmit">
        <div class="radius-input">
          <input type="number" v-model="driverFilter.miles" />
          <label>{{ $t('dispatch.map.filterControls.labelRadius') }}</label>
        </div>

        <div class="service-types" v-if="!rsvpInMap.isPackage && !qualifiedDrivers.active">
          <div class="title">{{ $t('dispatch.map.filterControls.labelServices') }}</div>
          <div class="row">
            <div class="small-12 columns" v-for="service in driverFilter.services" :key="service.id">
              <label>
                <input type="checkbox" :value="service.id" v-model="driverFilter.serviceTypes" />
                <span>{{ service.name }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="service-types" v-if="qualifiedDrivers.active">
          <div class="title">Qualification Criteria:</div>
          <div class="row">
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.seatCapacity" />
                <span>Seat Capacity Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.serviceTypes" />
                <span>Service Types Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.adaWC" />
                <span>ADA: Wheelchair Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.adaSD" />
                <span>ADA: Service Dog Restriction</span>
              </label>
            </div>
            <div class="small-12 columns" v-if="false">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.fullTNC" />
                <span>License Type Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.availability" />
                <span>Availability Restriction</span>
              </label>
            </div>
          </div>
          <div class="filter-note"
            v-if="!qualifiedFilter.seatCapacity || !qualifiedFilter.serviceTypes || !qualifiedFilter.adaWC || !qualifiedFilter.adaSD || !qualifiedFilter.fullTNC || !qualifiedFilter.availability">
            Changing the qualification criteria will also disable the checks for driver's upcoming trip conflicts, tight route, and work hours.
          </div>
        </div>

        <div class="divider" v-if="!rsvpInMap.isPackage"></div>

        <div class="button-wrapper">
          <button class="cta block success">
            {{ $t('dispatch.map.filterControls.labelButton') }}
          </button>
        </div>
      </form>
    </div>
    
    <div :class="['search-status', {hide: (nearbyDrivers.length <= 0 || mapLoader.show)}]">
      We found driver(s) for this reservation.
      <!-- <span v-if="isQualifiedDriver">
        <span v-if="false">We found {{qualifiedCount}} possible driver{{qualifiedCount > 1 ? 's' : ''}} for the pickup.</span>
        We found driver(s) for this reservation.
      </span>
      <span v-else>
        We found {{ nearbyDrivers.length }} {{ nearbyDrivers.length > 1 ? 'drivers' : 'driver' }} within {{ searchStatus.miles }} {{ searchStatus.miles > 1 ? 'miles' : 'mile' }} of the pickup.
      </span> -->
    </div>

    <div :class="['map-loader', {hide: !mapLoader.show}]">{{ mapLoader.label }}</div>

    <div :class="['dispatch-modal', {show: modal.show}]" @click="close">
      <div class="dispatch-modal-container">
        <div class="dispatch-modal-content" @click.stop>
          <div class="validation-modal">
            <div class="title">Send to driver</div>
            <div class="message">Accept Request Timeout</div>
            <label class="option" @click="modal.option = 'default'">
              <input type="radio" name="crt" checked="checked" v-if="modal.show" />
              <span class="s">Default ({{$settings.get('ASAPRequestTimeout')}} sec)</span>
            </label>
            <label class="option" @click="modal.option = 'custom'">
              <input type="radio" name="crt" v-if="modal.show" />
              <div class="input-integer" style="display: inline-block">
                <input type="number" v-model="modal.custom" /> <span>secs</span>
              </div>
              <!-- <input type="text" v-model="modal.custom" /> -->
            </label>
            <div style="padding: 10px 50px;margin: 30px 0 10px;">
              <a class="button success block" href="javascript:;" @click="sendToDriver">Yes</a>
              <a class="cancel" href="javascript:;" @click="close">No, I change my mind</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="['lr-modal', {'hide': !queueError.show}]">
      <div class="lr-box">
        <div class="lr-alert-msg" v-html="queueError.message"></div>
        <a class="button cta small right block" @click="showReasons">View Driver Qualification Checks</a>
        <div class="show-reasons-btn" @click="queueError.show = false">Dismiss</div>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import mapSettings from '@/values/map-settings'
import mapPinsSettings from '@/values/map-pin'
import moment from 'moment'

import services from '@/modules/api/services'
import PulseLoader from '@/components/Partials/LoadingAnimation/Pulse'
import ApiDispatchDrivers from '@/modules/api/dispatch/drivers'
import ft from '@/modules/api/featureToggle'

// import DriverPopup from './DriverPopup'
export default {
  name: 'dispatch-map2',
  components: { PulseLoader },
  data () {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      mapOptions: mapSettings,
      pickupPin: mapPinsSettings.pickup,
      dropoffPin: mapPinsSettings.dropoff,
      center: { lat: 33.942791, lng: -118.410042 }, // LAX
      carPin: mapPinsSettings.car,
      mapPins: [],
      mapLoader: {
        show: false,
        label: 'LOADING RESERVATION...'
      },
      route: { rsvp: [] },
      rsvp: null,
      driverFilter: {
        show: false,
        isLoading: false,
        miles: 10,
        serviceTypes: [],
        services: [],
        serviceLoading: false
      },
      searchStatus: { miles: 10 },
      showDriverInfoWindow: false,
      driverInfoIndex: 0,
      driverDistance: [],
      driverPresentation: false,
      current: {
        driversInMap: [],
        nearbyDrivers: [],
        openDriver: ''
      },
      waiting: {
        renderDriver: {
          data: '',
          process: false
        },
        beginDriverPresentation: false
      },
      driverRoutes: {},
      upcoming: {
        loading: false,
        rsvp: null
      },
      driverManualOpen: false,
      delayFindNearBy: '',
      delayBeginDriverPresentation: '',
      driverPresented: [],
      driverLocation: {
        lat: '',
        lng: ''
      },
      driverDestination: {
        lat: '',
        lng: ''
      },
      trackDriverDelay: '',
      modal: {
        show: false,
        option: 'default',
        custom: 60
      },
      lastServiceAvailableCheck: {
        id: 0,
        date: moment()
      },
      isQualifiedDriver: false,
      qualifiedCount: 0,
      nearByQualifiedDrivers: {
        raw: [],
        qualified: []
      },
      qualifiedFilter: {
        serviceTypes: 1,
        seatCapacity: 1,
        adaWC: 1,
        adaSD: 1,
        fullTNC: 1,
        availability: 1,
      },
      runValidate: true,
      queueError: {
        show: false,
        message: ''
      },
      lastDriverType: '',
      tmpProvData: null,
      currentDriver: null
    }
  },
  computed: {
    dispatch () { return this.$store.state.dispatch },
    driver () { return this.dispatch.driverInPopup },
    rsvpInMap () { return this.dispatch.rsvpInMap },
    nearbyDrivers () { return this.dispatch.driversNearRsvp },
    driversInMap () { return this.dispatch.driversInMap },
    driverPopupRoute () { return this.dispatch.driverInPopupRoute },
    isUpcomingAndReqDispatch () {
      return this.rsvpInMap.status === 'UPCOMING' || this.rsvpInMap.status === 'REQUIRES DISPATCH'
    },
    _rsvpInMapPickup () { return this.dispatch.rsvpInMap.pickup },
    rsvpAvailabilityLoading: {
      get () { return this.dispatch.availableDrivers.loading },
      set (x) { this.$store.commit('dispatch/setAvailableDriversData', {loading: x})}
    },
    rsvpAvailableDrivers () { return this.dispatch.availableDrivers.list },
    qualifiedDrivers () { return this.dispatch.qualifiedDriver }
  },
  methods: {
    setMapPins (pins) {
      let self = this

      for (let object of self.hereMaps.map.getObjects()) {
        self.hereMaps.map.removeObject(object)
      }
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })

      for (let i = 0; i < pins.length; i++) {
        let item = pins[i]

        // Pickup/Dropoff icon
        let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg>'

        let pickupDropoff = item.isPickup ? 'pickup' : 'dropoff'
        if (item.isExtraStop) {
          pickupDropoff = 'stop'
        }

        marker = marker.replace('{D}', mapPinsSettings[pickupDropoff].path)
          .replace('{STROKE}', mapPinsSettings[pickupDropoff].strokeColor)
          .replace('{STROKE_WIDTH}', mapPinsSettings[pickupDropoff].strokeWeight)
          // .replace('{FILL}', mapPinsSettings[pickupDropoff].fillColor)
        if (item.status === 'complete') {
          marker = marker.replace('{FILL}', mapPinsSettings.pickup.fillColor)
        } else {
          marker = marker.replace('{FILL}', mapPinsSettings[pickupDropoff].fillColor)
        }
        let icon = new window.H.map.DomIcon(marker)
        let coords = {lat: item.lat, lng: item.lng}
        let pin = new window.H.map.DomMarker(coords, {icon: icon})
        pin.id = 'marker' + i
        pin.lat = item.lat
        pin.lng = item.lng
        self.hereMaps.map.addObject(pin)
      }

      self.setRoute(pins, {isDriverRoute: false})
      if (self.trackDriverDelay) {
        clearTimeout(self.trackDriverDelay)
      }
      if (self.rsvpInMap.isPackage) {
        self.trackDriver()
      }
    },
    setRoute (items, extraData) {
      let self = this

      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
      items.forEach((coords, index) => {
        if (index == 0) {
          url += `&origin=${coords.lat},${coords.lng}`
        } else if (index == items.length - 1) {
          url += `&destination=${coords.lat},${coords.lng}`
        } else {
          url += `&via=${coords.lat},${coords.lng}`
        }
      })
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          self.onCalculateError()
          return
        }
        self.onCalculateSuccess(extraData, body)
      })
    },
    onCalculateSuccess (extraData, result) {
      if (extraData.isTrackDriver) {
        this.setTrackDriverPin(result)
        return
      }
      if (!result.routes.length) return
      if (extraData.isDriverRoute) {
        let res = result.routes[0].sections[0].summary
        let distance = Math.round((res['length'] * .001) * 0.6214) + ' miles, ' + Math.round(res.duration / 60) + ' minutes away'
        if (res['length'] === 0 && res.duration === 0) {
          let tempElement = document.createElement('html')
          tempElement.innerHTML = res.text
          let miles = tempElement.getElementsByTagName('span')[0].innerText
          miles = Math.round(parseFloat(miles.substring(0, miles.length - 2)) * 0.6212)
          let time = tempElement.getElementsByTagName('span')[1].innerText
          time = time.substring(0, time.length - 4)

          distance = miles + ' miles, ' + time + ' minutes away'
        }
        this.driverRoutes['a' + extraData.id] = distance
      }
      var route = result.routes[0].sections
      this.addRouteShapeToMap(route, extraData)
    },
    onCalculateError (data) {
      console.error('ROUTING ERROR', data)
    },
    addRouteShapeToMap (routes, extraData, distance) {
      let self = this
      routes.forEach((route, index) => {
        let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
        let polyline = new window.H.map.Polyline(linestring, {
          style: {
            lineWidth: 4,
            strokeColor: extraData.isDriverRoute ? '#2EE47D' : 'rgba(25, 25, 25, 0.7)'
          }
        });
        polyline.id = `rsvpRoute${index}`

        if (extraData.isDriverRoute) {
          for (let object of self.hereMaps.map.getObjects()) {
            if (object.id.indexOf('driverRoute') > -1) {
              object.setVisibility(0)
            }
          }
          polyline.id = 'driverRoute' + extraData.id
          polyline.setVisibility(1)

          let driverData = self.$store.state.dispatch.driversNearRsvp
          let index = driverData.findIndex(x => x.id === extraData.id)
          if (index > -1) {
            self.displayDriverInfo(driverData[index], 1)
          }
        }
        this.hereMaps.map.addObject(polyline)
      })
      this.setCenter('location', {})

      if (!extraData.isDriverRoute) {
        if (self.rsvp.driver === null) {
          if (self.delayFindNearBy) {
            clearTimeout(self.delayFindNearBy)
          }
          self.delayFindNearBy = setTimeout(function () {
            if (!self.rsvpInMap.isPackage) {
              self.driverFilter.serviceTypes = []
              self.driverFilter.serviceTypes.push(self.rsvpInMap.serviceId)
            }

            let now = moment()
            let pickupTime = moment(self.rsvpInMap.pickupTime, 'MM/DD/YYYY hh:mmA')
            let diff = pickupTime.diff(now, 'minute')
            // let limit = self.rsvpInMap.isPackage ? parseInt(self.$settings.get('findNearbyDriverLimit')) : 60
            let limit = parseInt(self.$settings.get('findNearbyDriverLimit'))
            self.upcoming.loading = true
            self.upcoming.rsvp = null
            if (diff <= limit) {
              self.isQualifiedDriver = false
              self.$store.commit('dispatch/setQualifiedDriversData', {active: false})
              self.findNearbyDrivers()
            } else {
              self.isQualifiedDriver = true
              self.$store.commit('dispatch/setQualifiedDriversData', {active: true})
              self.findQualifiedDrivers()
            }
          }, 1000)
        } else {
          self.$store.commit('dispatch/setLoadingRsvpId', null)
          self.$store.commit('dispatch/setDriversNearRsvp', [])
        }
      }
    },
    serviceLabel (code) { return services.getServiceName(code) },
    updateDriverLocation (driver, triggerPopup) {
      let self = this
      ApiDispatchDrivers.getLocation(self, driver.id, location => {
        if (location.error || (location && !location.list.length)) { return }
        let coords = {
          lat: location.list[0].lat,
          lng: location.list[0].lng
        }

        driver.coords = coords
        if (triggerPopup) {
          self.showDriverInfo(driver, false)
          self.$store.commit('dispatch/removeDriverInMap', driver)
          self.$store.commit('dispatch/addDriverInMap', driver)
        } else {
          let routeCoords = [
            {lat: location.list[0].lat, lng: location.list[0].lng},
            {lat: self._rsvpInMapPickup.lat, lng: self._rsvpInMapPickup.lng}
          ]
          self.setRoute(routeCoords, {isDriverRoute: true, id: driver.id})
        }

        if (self.rsvpInMap.id === null || self.rsvpInMap.driver === null) { return }
      })
    },
    showDriverInfo (driver, focus) {
      let self = this
      self.$store.commit('dispatch/showDriverInPopup', driver)

      // if (self.rsvp === null) { return }

      self.showDriverInfoWindow = false
      if (self.driverPresentation || typeof focus === 'undefined') {
        self.$nextTick(() => {
          self.showDriverInfoWindow = true
        })
      }

      if (focus) {
        self.setCenter('custom', {lat: driver.coords.lat, lng: driver.coords.lng})
      } else {
        self.driverPresentation = false
      }
      self.updateDriverLocation(driver, false)
    },
    setCenter (type, data) {
      let self = this
      let group = new window.H.map.Group()

      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id === 'groupBound') {
          self.hereMaps.map.removeObject(object)
        }
      }

      let groupObject = []
      if (type === 'location') {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('marker') > -1) {
            groupObject.push(new window.H.map.Circle(
              new window.H.geo.Point(object.lat, object.lng),
              5000,
              { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }
            ))
          }
        }
      } else if (type === 'driver') {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('driverInMap') > -1 ||
            object.id.indexOf('nearbyDrivers') > -1
          ) {
            groupObject.push(new window.H.map.Circle(
              new window.H.geo.Point(object.lat, object.lng),
              5000,
              { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }
            ))
          }
        }
      } else if (type === 'custom') {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(data.lat, data.lng),
          5000,
          { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }
        ))
      }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject)
        group.id = 'groupBound'
        self.hereMaps.map.addObject(group)
  
        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        })
      }
    },
    setDriverPin (showOnly = false) {
      let self = this

      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('nearbyDrivers') > -1) {
          let id = parseInt(object.id.substring(13))
          let index = self.nearbyDrivers.findIndex(x => x.id === id)
          if (index > -1) {
            self.hereMaps.map.removeObject(object)
            self.current.nearbyDrivers = self.current.nearbyDrivers.filter(driverId => {
              return driverId !== id
            })
          }
        }
      }

      let firstDriver = true
      self.nearbyDrivers.forEach((driver, x) => {
        if (self.current.driversInMap.indexOf(driver.id) > -1) { return }

        let marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg>'

        marker = marker.replace('{D}', mapPinsSettings.car.path)
          .replace('{FILL}', x == 0 ? '#38b550' : mapPinsSettings.car.fillColor)
          .replace('{STROKE}', mapPinsSettings.car.strokeColor)
          .replace('{STROKE_WIDTH}', x == 0 ? '.2' : mapPinsSettings.car.strokeWeight)

        let icon = new window.H.map.DomIcon(marker, {
          onAttach: (cloned, icon, marker) => {
            cloned.addEventListener('click', evt => {
              self.displayDriverInfo(driver, 2, showOnly)
            })
          },
          onDetach: (cloned, icon, marker) => {
            cloned.removeEventListener('click', evt => {})
          }
        })
        let coords = {lat: driver.coords.lat, lng: driver.coords.lng}
        let pin = new window.H.map.DomMarker(coords, {icon: icon})
        pin.id = 'nearbyDrivers' + driver.id
        pin.lat = driver.coords.lat
        pin.lng = driver.coords.lng
        self.current.nearbyDrivers.push(driver.id)
        self.hereMaps.map.addObject(pin)
        if (self.driverPresented.indexOf(driver.id) === -1 && firstDriver) {
          firstDriver = false
          self.driverPresented.push(driver.id)
          self.displayDriverInfo(driver, 3, showOnly)
        }
        // if (firstDriver) {
        //   firstDriver = false
        //   self.displayDriverInfo(driver, 3, showOnly)
        // }
      })

      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('driverInMap') > -1) {
          let id = parseInt(object.id.substring(11))
          let index = self.driversInMap.findIndex(x => x.id === id)
          if (index === -1) {
            self.hereMaps.map.removeObject(object)
            self.current.driversInMap = self.current.driversInMap.filter(driverId => {
              return driverId !== id
            })
          }
        }
      }

      setTimeout(() => {
        self.driversInMap.forEach((driver, x) => {
          if (self.current.driversInMap.indexOf(driver.id) > -1) { return }

          let marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' +
            '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
            'stroke-width="{STROKE_WIDTH}" /></svg>'

          marker = marker.replace('{D}', mapPinsSettings.car.path)
            .replace('{FILL}', x == 0 ? '#38b550' : mapPinsSettings.car.fillColor)
            .replace('{STROKE}', mapPinsSettings.car.strokeColor)
            .replace('{STROKE_WIDTH}', x == 0 ? '.2' : mapPinsSettings.car.strokeWeight)

          let icon = new window.H.map.DomIcon(marker, {
            onAttach: (cloned, icon, marker) => {
              cloned.addEventListener('click', evt => {
                self.displayDriverInfo(driver, 4, showOnly)
              })
            },
            onDetach: (cloned, icon, marker) => {
              cloned.removeEventListener('click', evt => {})
            }
          })
          let coords = {lat: driver.coords.lat, lng: driver.coords.lng}
          let pin = new window.H.map.DomMarker(coords, {icon: icon})
          pin.id = 'driverInMap' + driver.id
          pin.lat = driver.coords.lat
          pin.lng = driver.coords.lng
          self.current.driversInMap.push(driver.id)
          self.hereMaps.map.addObject(pin)
          if (firstDriver) {
            firstDriver = false
            self.displayDriverInfo(driver, 5, showOnly)
          }
        })
      }, 300)

      // if (self.current.driversInMap.length === 0 && self.current.nearbyDrivers.length === 0) {
      //   // self.setCenter('custom', {lat: 33.942791, lng: -118.410042})
      //   return
      // }

      self.setCenter('driver', {})
    },
    displayDriverInfo (driver, x, showOnly = false) {
      let self = this

      // Display route from this driver
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('driverRoute') > -1) {
          object.setVisibility(0)
          // if (object.id === 'driverRoute' + driver.id) {
          //   self.current.openDriver = driver.id
          //   object.setVisibility(1)
          // }
        }
      }

      // Remore existing info bubble
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })

      let driverIndex = self.driverDistance.findIndex(x => x.id === driver.id)
      self.$store.commit('dispatch/setDriverInPopupRoute', self.driverDistance[driverIndex])

      let bubbleId = 'driverInfo_' + driver.id

      let bubbles = self.hereMaps.ui.getBubbles()
      for (let i = 0; i < bubbles.length; i++) {
        let item = bubbles[i]
        if (item.id !== bubbleId) {
          continue
        }
        self.hereMaps.ui.removeBubble(item)
      }

      let showDispatchButtons = self.rsvpInMap.id !== null && (self.rsvpInMap.status === 'UPCOMING' || self.rsvpInMap.status === 'REQUIRES DISPATCH') 

      let bubbleContent = '<div class="info-container">' +
        '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>' +
        '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>' +
        '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>'
        '</div>'

      if (showDispatchButtons) {
        bubbleContent = '<div class="info-container">' +
          '<div class="prvNxt prev" id="driverPrev_{DRIVER_ID}"><i class="fas fa-chevron-left"></i></div>'+
          '<div class="prvNxt next" id="driverNext_{DRIVER_ID}"><i class="fas fa-chevron-right"></i></div>'+
          // '<div class="upcoming-rsvp" style="display:none">{UPCOMING_INFO}</div>' +
          '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a><span>{DRIVER_DISTANCE}</span>'+
            (!showOnly ? '<a id="DriverSend_{DRIVER_ID}" class="assign-button button cta xsmall warning block" href="javascript:;">SEND TO {DRIVER_FNAME}</a>' : '') +'</div>' +
          '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span>' +
            (!showOnly ? '<a id="DriverAssign_{DRIVER_ID}" class="assign-button button cta xsmall block" href="javascript:;">ASSIGN TO {DRIVER_FNAME}</a>' : '') + '</div>' +
          '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod"><i class="fas fa-phone"></i> CALL {DRIVER_FNAME}</a>'
          '</div>'

        let upcomingInfo = ''
        if (self.upcoming.loading) {
          upcomingInfo = '<i class="fa fa-spinner fa-spin"></i><span> Checking for upcoming reservations...</span>'
        } else if (!self.upcoming.loading && self.upcoming.rsvp === null) {
          upcomingInfo = 'No Upcoming Reservations.'
        } else if (!self.upcoming.loading && self.upcoming.rsvp !== null) {
          upcomingInfo = 'Upcoming '
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'package') {
            upcomingInfo = upcomingInfo + '<span>Package </span>' +
              ' (<a href="/#/package/' + self.upcoming.rsvp.data.package.id + '" target="_blank">' + self.upcoming.rsvp.data.package.id + '</a>) at ' +
              ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupTime) + '.</span>'
          }
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'rsvp') {
            upcomingInfo = upcomingInfo + '<span>RSVP </span>' +
              ' (<a href="/#/reservation/' + self.upcoming.rsvp.data.ID + '" target="_blank">' + self.upcoming.rsvp.data.ID + '</a>) at ' +
              ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupDate) + '.</span>'
          }
        }
        bubbleContent = bubbleContent.replace('{UPCOMING_INFO}', upcomingInfo)
      }

      self.currentDriver = driver
      bubbleContent = bubbleContent.replace('{DRIVER_PHOTO}', driver.photoUrl)
        .replaceAll('{DRIVER_ID}', driver.id)
        .replace('{DRIVER_URL}', '/#/provider/' + driver.id)
        .replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName)
        .replace('{DRIVER_DISTANCE}', self.driverRoutes['a' + driver.id] || '&nbsp;')
        .replace('{DRIVER_FNAME}', driver.firstName)
        .replace('{DRIVER_FNAME}', driver.firstName)
        .replace('{DRIVER_FNAME}', driver.firstName)
        .replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl)
        .replace('{VEHICLE_NAME}', driver.vehicle.name)
        .replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate)

      let bubble = new window.H.ui.InfoBubble({
        lat: driver.coords.lat,
        lng: driver.coords.lng
      }, {
        content: bubbleContent,
        onStateChange: aa => {
          if (driver.isQualified) {
            if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
             else self.validateQualifiedDrivers()
            return
          }

          if (!self.nearByQualifiedDrivers.raw.length) self.noQualifiedDrivers()
          else self.checkDriverQualification()
        }
      })
      bubble.id = bubbleId
      bubble.addClass('H_driver-info')
      self.hereMaps.ui.addBubble(bubble)

      let driverPrev = document.getElementById(`driverPrev_${driver.id}`)
      let driverNext = document.getElementById(`driverNext_${driver.id}`)
      let elem = document.getElementById('DriverCall_' + driver.id)
      let assignElem = document.getElementById('DriverAssign_' + driver.id)
      let sendElem = document.getElementById('DriverSend_' + driver.id)

      
      setTimeout(() => {
        if (driverPrev) {
          driverPrev.classList.remove('disabled')
          if (self.driverInfoIndex <= 0) {
            driverPrev.classList.add('disabled')
          } else {
            driverPrev.addEventListener('click', evt => {
              self.beginDriverPresentation(false)
            })
          }
        }

        if (driverNext) {
          let driverData = self.$store.state.dispatch.driversNearRsvp
          driverNext.classList.remove('disabled')
          if ((driverData.length - 1) <= self.driverInfoIndex) {
            driverNext.classList.add('disabled')
          } else {
            driverNext.addEventListener('click', evt => {
              self.beginDriverPresentation(true)
            })
          }
        }

        if (elem) {
          elem.addEventListener('click', evt => {
            self.callDriver(driver)
          })
        }

        if (showDispatchButtons) {
          if (assignElem) {
            assignElem.addEventListener('click', evt => {
              self.assignToDriver(driver)
            })
          }

          if (sendElem) {
            sendElem.addEventListener('click', evt => {
              self.sendToDriver(driver)
            })
          }
        }
      }, 500)
    },
    callDriver (driver) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      })
    },
    sendToDriver (driver) {
      let self = this
      let rsvp = self.rsvpInMap
      this.modal.show = false

      let url = '/admin/rsvp/'
      if (rsvp.isPackage) {
        url = '/admin/package/'
      }
      self.$store.commit('dispatch/showActionModal',
        'Sending' +  (rsvp.isPackage ? ' package ' : ' reservation ') + 'to driver...')

      let customRequestTimeout = self.$settings.get('ASAPRequestTimeout')
      if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom
      self.$sdk.post(url + rsvp.id + '/send', {
        token: self.$store.state.session.sessionToken,
        provId: driver.id,
        customRequestTimeout: customRequestTimeout
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          })
        } else {
          self.$store.commit('dispatch/setPendingOffer', {
            id: rsvp.id,
            show: true,
            timer: parseInt(customRequestTimeout) + 10
          })
          // self.$store.commit('dispatch/removeRsvpInTable', rsvp)
          self.$store.commit('dispatch/setSelectedDriver', null)
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation.'
          })
        }

        setTimeout ( () => {
          self.$store.commit('dispatch/closeActionModal')
        }, 1000)
      })
    },
    assignToDriver (driver) {
      let self = this
      let rsvp = self.rsvpInMap

      self.$store.commit('dispatch/showActionModal',
        'Assigning ' +  (rsvp.isPackage ? 'package' : 'reservation') + ' to driver...')

      let request = {
        token: self.$store.state.session.sessionToken,
        rsvpId: rsvp.id
      }
      if (rsvp.isPackage) {
        request = {
          token: self.$store.state.session.sessionToken,
          packageId: rsvp.id
        }
      }

      self.$sdk.post('/provider/' + driver.id + '/assign', request, r => {
        if (r.error) {
          console.log('ERROR', r)
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          })
        } else {
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully assigned items to driver.'
          })
        }
        setTimeout ( () => {
          self.$store.commit('dispatch/closeActionModal')
        }, 1000)
      })
    },
    getNextRoute () {
      let self = this
      let rsvp = self.rsvp
      if (rsvp === null) {
        return null
      }

      for (let i = 0; i < rsvp.route.length; i++) {
        let route = rsvp.route[i]

        if (route.status === 'upcoming' || route.status === 'requires_dispatch' || route.status === 'dispatched') {
          return route
        }
      }
      return null
    },
    findNearbyDrivers () {
      let self = this
      if (self.driverFilter.isLoading) { return }

      // GET AVAILABLE DRIVERS - CROSS FILTER
      // if (self.lastServiceAvailableCheck.id !== self.rsvp.id ||
      //   (self.lastServiceAvailableCheck.id === self.rsvp.id && self.lastServiceAvailableCheck.date.diff(moment(), 'minute') < -5)
      // ) {
      //   self.getAvailableDrivers(self.rsvp)
      //   return
      // }

      self.driverFilter.isLoading = true
      self.mapLoader = {
        show: true,
        label: 'FINDING NEARBY DRIVERS...'
      }

      let serviceId = []
      if (self.rsvpInMap.isPackage) {
        let services = this.$store.state.services
        services.list.forEach(service => {
          if (service.isShared && service.enabled) {
            serviceId.push(service.id)
          }
        })
      } else {
        self.driverFilter.serviceTypes.forEach(id => {
          if (id) { serviceId.push(id) }
        })
      }

      // Remove info bubble
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })
      // Remove current drivers
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('nearbyDrivers') > -1) {
          self.hereMaps.map.removeObject(object)
        }
      }

      self.lastDriverType = 'nearby'
      ApiDispatchDrivers.getNearbyDrivers(self, {
        token: self.$store.state.session.sessionToken,
        lat: self.rsvp.pickup.lat,
        lng: self.rsvp.pickup.lng,
        radius: self.driverFilter.miles,
        duty: 1,
        serviceTypeId: serviceId,
        // serviceTypeId: self.driverFilter.serviceTypes,
        order: 'distance',
        orderAsc: 1
      }, r => {
        self.nearByDriversRaw = []
        // self.driverPresentation = true
        self.driverFilter.isLoading = false
        self.mapLoader = {
          show: false,
          label: ''
        }
        self.$store.commit('dispatch/setLoadingRsvpId', null)
        self.$store.commit('dispatch/setDriversNearRsvp', [])
        if (r.error) {
          self.mapLoader = {
            show: false,
            label: ''
          }
          self.setCenter()
          return
        }

        if (r.list.length <= 0) {
          self.mapLoader = {
            show: false,
            label: ''
          }
          self.driverFilter.show = true
          self.setCenter()
          return
        }

        self.driverFilter.show = false
        self.showDriverInfoWindow = false

        let driversNearby = []
        for (let i = 0; i < r.list.length; i++) {
          let driver = r.list[i]
          // let isDriverAvailable = false
          // if (self.rsvpAvailableDrivers.length) {
          //   isDriverAvailable = self.rsvpAvailableDrivers.findIndex(x => x.id === driver.ID) > -1
          // }
          // if (typeof driver.tracks === 'undefined' || !isDriverAvailable) {
          //   continue
          // }
          let driverData = {
            id: driver.ID,
            phone: driver.phone,
            firstName: driver.firstName,
            lastName: driver.lastName,
            photoUrl: driver.avatarUrl,
            coords: {
              lat: driver.tracks.lat,
              lng: driver.tracks.lng,
              header: driver.tracks.heading
            },
            vehicle: {
              name: driver.vehicle.manufacturer + ' ' + driver.vehicle.model,
              licensePlate: driver.vehicle.licensePlate,
              photoUrl: driver.vehicle.photoUrl
            }
          }
          driversNearby.push(driverData)
          self.nearByQualifiedDrivers.raw.push(driverData)

          self.waiting.renderDriver.process = true
          self.waiting.renderDriver.data = driver
          self.driverDistance.push({
            id: driver.ID,
            distance: self.calculateDistance(
              {lat: driver.tracks.lat, lng: driver.tracks.lng},
              {lat: self.rsvpInMap.pickup.lat, lng: self.rsvpInMap.pickup.lng}
            )
          })
          if (i + 1 === r.list.length) {
            if (self.isUpcomingAndReqDispatch) { self.driverPresentation = true }
            self.$store.commit('dispatch/setDriversNearRsvp', driversNearby)
            // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)

            self.checkDriverQualification()
          }

          self.searchStatus.miles = self.driverFilter.miles
        }
        self.setDriverPin()
        self.driverPresented = []
        self.setCenter()
      })
    },
    checkDriverQualification () {
      let self = this
      if (!self.nearByQualifiedDrivers.raw.length) return
      let driverId = self.nearByQualifiedDrivers.raw[0].id
      self.mapLoader = {
        show: true,
        label: 'Checking for qualified drivers...'
      }
      self.$sdk.get(`/reservation/${self.rsvpInMap.id}/validate`, {
        token: self.$store.state.session.sessionToken,
        providerId: driverId
      }, r => {
        if (r.error) {
          self.nearByQualifiedDrivers.raw.shift()
          if (!self.nearByQualifiedDrivers.raw.length) {
            self.mapLoader = {
              show: false,
              label: ''
            }
            self.driverFilter.show = true
            self.setCenter()
          }
          else self.checkDriverQualification()
          return
        }
        self.mapLoader = {
          show: false,
          label: ''
        }

        let driverDetails = {...self.nearByQualifiedDrivers.raw[0]}
        self.showDriverInfo(driverDetails, true)
        self.nearByQualifiedDrivers.raw.shift()
        // self.getDriverDetails(driverId)
      }, '2.0')
    },
    beginDriverPresentation (isNext) {
      let self = this

      // if (self.isUpcomingAndReqDispatch) {
      let driverData = self.$store.state.dispatch.driversNearRsvp
      // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)
      if (!self.driverDistance.length) {
        self.waiting.beginDriverPresentation = true
        return
      }

      if (!isNext && self.driverInfoIndex > 0) {
        self.driverInfoIndex--
      } else if (isNext && self.driverInfoIndex < driverData.length - 1) {
        self.driverInfoIndex++
        if (driverData[self.driverInfoIndex].id === self.currentDriver.id) self.driverInfoIndex++
      }
      if (driverData[self.driverInfoIndex]) {
        let index = driverData.findIndex(x => x.id === self.driverDistance[self.driverInfoIndex].id)
        if (index === -1) { index = 0 }
        self.showDriverInfo(driverData[index], true)
        // if (isNext) self.driverInfoIndex++
      } else {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'No more nearby drivers found.',
        })
      }
      // self.setDriverPin()
      // }
    },
    calculateDistance (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      let distance = R * c
      return distance / 1.609344
    },
    resizeMap () {
      let self = this
      setTimeout(function () {
        self.hereMaps.map.getViewPort().resize()
      }, 600)
    },
    formatTime (time) { return moment(time).format('MM/DD/YYYY hh:mm A') },
    filterServices () {
      let self = this
      let services = this.$store.state.services

      if (!services.list.length) {
        this.getServices()
        return
      }

      self.driverFilter.services = []
      services.list.forEach(service => {
        if (self.rsvpInMap.isPackage) {
          if (service.isShared && service.enabled) {
            let name = service.label
            let brandIndex = CONFIG.brands.findIndex(x => x.id === service.brandId)
            if (brandIndex > -1) {
              name = `[${CONFIG.brands[brandIndex].code.toUpperCase()}] ${name}`
            }
            self.driverFilter.services.push({
              id: service.id,
              brandId: service.brandId,
              name: name,
            })
          }
        } else {
          if (service.brandId === self.rsvpInMap.brandId) {
            self.driverFilter.services.push({
              id: service.id,
              brandId: service.brandId,
              name: service.label,
            })
          }
        }
      })
    },
    getServices () {
      let self = this
      self.driverFilter.serviceLoading = true
      services.getAllService(self, r => {
        self.driverFilter.serviceLoading = false
        self.filterServices()
      })
    },
    trackDriver () {
      let self = this

      let stops = []
      self.rsvpInMap.route.forEach(route => {
        if (!route.isPickup) {
          stops.push(route.rsvpID)
        }
      })

      let rsvp = ''
      stops.every((stop, index) => {
        rsvp = self.rsvpInMap.rsvps.find(x => x.id === stop && ['ontheway', 'arrived', 'onboard'].indexOf(x.rsvpStatus) > -1)
        return !rsvp ? true : false
      })

      if (self.trackDriverDelay) {
        clearTimeout(self.trackDriverDelay)
      }

      if (rsvp) {
        self.$sdk.get(`/provider/${rsvp.driver.id}/tracks`, {token: self.$store.state.session.sessionToken}, res => {
          if (!res.error && res.list.length) {
            self.driverLocation = {
              lat: res.list[0].lat,
              lng: res.list[0].lng
            }
            self.driverDestination = {
              lat: rsvp.dropoff.lat,
              lng: rsvp.dropoff.lng
            }
            // if (stops[0] === rsvp.id && rsvp.rsvpStatus === 'ontheway') {
            //   self.driverDestination = {
            //     lat: rsvp.pickup.lat,
            //     lng: rsvp.pickup.lng
            //   }
            // }
            self.setRoute([self.driverLocation, self.driverDestination], {isDriverRoute: false, isTrackDriver: true})
          }
        })
      } else {
        self.trackRemoveDriver()
      }
    },
    setTrackDriverPin (data) {
      let self = this
      self.trackRemoveDriver()

      let marker = `
        <svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">
          <path d="{D}" fill="{FILL}"stroke="{STROKE}" stroke-width="{STROKE_WIDTH}" />
        </svg>`
      marker = marker.replace('{D}', mapPinsSettings.car.path)
        .replace('{FILL}', mapPinsSettings.car.fillColor)
        .replace('{STROKE}', mapPinsSettings.car.strokeColor)
        .replace('{STROKE_WIDTH}', mapPinsSettings.car.strokeWeight)

      let icon = new window.H.map.DomIcon(marker)
      let pin = new window.H.map.DomMarker(self.driverLocation, {icon: icon})
      pin.id = 'driverPin'
      pin.lat = self.driverLocation.lat
      pin.lng = self.driverLocation.lng

      let content = `
        <div class="info-container">
          <div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>
          <div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>
          <div class="eta-to-dropoff"><label>ETA to next dropoff</label><span class="value">{ETA}</span></div>
          <a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>
        </div>
      `
      let driver = self.rsvpInMap.driver
      content = content.replace('{DRIVER_PHOTO}', driver.photoUrl)
        .replace('{DRIVER_URL}', '/#/provider/' + driver.id)
        .replace('{DRIVER_ID}', driver.id)
        .replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName)
        .replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl)
        .replace('{VEHICLE_NAME}', driver.vehicle.name)
        .replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate)
        .replace('{DRIVER_FNAME}', driver.firstName)
      let travelTime = data.routes.length ? data.routes[0].sections[0].summary.duration : 0
      if (travelTime > 60) {
        content = content.replace('{ETA}', Math.ceil(travelTime / 60) + ' minute(s)')
      } else {
        content = content.replace('{ETA}', travelTime + ' second(s)')
      }
      let bubble = new window.H.ui.InfoBubble(self.driverLocation, {content: content})
      bubble.addClass('H_driver-info')
      bubble.id = 'driverBubble'
      bubble.open()
      self.hereMaps.ui.addBubble(bubble)
      pin.addEventListener('tap', function (evt) {
        bubble.open()
      }, false)
      self.hereMaps.map.addObject(pin)

      setTimeout(() => {
        let elem = document.getElementById('DriverCall_' + driver.id)
        elem.addEventListener('click', evt => {
          self.callDriver(driver)
        })
      }, 500)

      self.trackDriverDelay = setTimeout(() => {
        self.trackDriver()
      }, 15000)
    },
    trackRemoveDriver () {
      let self = this
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id === 'driverPin') {
          self.hereMaps.map.removeObject(object)
        }
      }
      self.hereMaps.ui.getBubbles().forEach(bub => {
        if (bub.id === 'driverBubble') {
          self.hereMaps.ui.removeBubble(bub)
        }
      })
    },
    getExtraStops (id) {
      let self = this

      self.$sdk.get(`/admin/rsvp/${id}/extrastops`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          return
        }
        if (r.list.length) {
          let pickup = self.rsvpInMap.pickup
          pickup.isPickup = true
          let dropoff = self.rsvpInMap.dropoff
          dropoff.isPickup = false
          let extraStop = r.list[0]
          extraStop.isExtraStop = true
          self.setMapPins([pickup, extraStop, dropoff])
        }
        // self.$forceUpdate()
      })
    },
    close () {
      this.modal.show = false
    },
    getAvailableDrivers (data) {
      if (!data.id) return
      if (data.status !== 'UPCOMING' && data.status !== 'REQUIRES DISPATCH') return

      let self = this
      if (self.rsvpAvailabilityLoading) return
      self.rsvpAvailabilityLoading = true
      self.lastServiceAvailableCheck = {
        id: data.id,
        date: moment()
      }

      let since = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').format('X')
      let until = moment(data.dropoffTime, 'MM/DD/YYYY hh:mmA').format('X')

      self.$sdk.get('/shifts/dashboard', {
        token: self.$store.state.session.sessionToken,
        assignments: 0,
        order: 'startShift',
        orderAsc: 1,
        pageNum: 1,
        sectorId: 0,
        serviceTypeId: data.serviceId,
        since: since,
        until: until
      }, res => {
        self.rsvpAvailabilityLoading = false
        if (res.error) {
          self.$store.commit('dispatch/setAvailableDriversData', {list: drivers})
          return
        }
        let drivers = []
        res.list.forEach(driver => {
          let name = driver.businessName || `${driver.firstName} ${driver.lastName}`
          let availableFrom = ''
          let availableUntil = ''
          if (driver.startTimestamp) {
            // let sinceTime = moment(since, 'X').format(ft.timeFormat(self, false))
            // availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
            availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
            availableUntil = moment(driver.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
          }
          drivers.push({
            id: driver.ID,
            name: name,
            firstName: driver.firstName,
            lastName: driver.lastName,
            licenseType: driver.accountType,
            homeSector: driver.homeSectorName || '',
            availableFrom: availableFrom,
            availableUntil: availableUntil,
            mobile: driver.phoneNumber || '',
          })
        })
        self.$store.commit('dispatch/setAvailableDriversData', {list: drivers})
        self.findNearbyDrivers()
      })
    },

    driverFilterSubmit () {
      if (this.qualifiedDrivers.active) {
        this.findQualifiedDrivers(true)
        this.driverFilter.show = false
      } else {
        this.findNearbyDrivers()
      }
    },
    findQualifiedDrivers (withFilter = false) {
      let self = this
      if (!self.rsvpInMap.id || self.driverFilter.isLoading) return
      self.driverFilter.isLoading = true

      self.mapLoader = {
        show: true,
        label: 'LOOKING FOR QUALIFIED DRIVERS...'
      }

      let params = {
        token: self.$store.state.session.sessionToken
      }
      if (withFilter) {
        params.distance = self.driverFilter.miles
        params.serviceTypes = self.qualifiedFilter.serviceTypes ? 1 : 0
        params.seatCapacity = self.qualifiedFilter.seatCapacity ? 1 : 0
        params.adaWC = self.qualifiedFilter.adaWC ? 1 : 0
        params.adaSD = self.qualifiedFilter.adaSD ? 1 : 0
        params.availability = self.qualifiedFilter.availability ? 1 : 0
      }
      self.runValidate = true
      if (withFilter && 
        (!self.qualifiedFilter.serviceTypes || !self.qualifiedFilter.seatCapacity ||
        !self.qualifiedFilter.adaWC || !self.qualifiedFilter.adaSD ||
        !self.qualifiedFilter.availability)
      ) {
        self.runValidate = false
      }
      self.lastDriverType = 'qualified'
      self.$sdk.get(`/reservation/${self.rsvpInMap.id}/queue`, params, r => {
        self.driverFilter.isLoading = false
        self.qualifiedCount = 0
        if (r.error) {
          self.mapLoader = {
            show: false,
            label: ''
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.qualifiedCount = r.list.length
        if (!r.list.length) {
          self.noQueueDrivers(r)
          return
        }

        self.$store.commit('dispatch/setQualifiedDriversData', {list: r.list})
        self.validateQualifiedDrivers(r)
        if (Object.keys(r.unqualified).length) self.buildReasons(r)
      }, '2.0')
    },
    validateQualifiedDrivers (data) {
      let self = this
      if (!self.qualifiedDrivers.list.length) return

      if (data) self.tmpProvData = data
      else if (self.tmpProvData) data = self.tmpProvData

      let driverId = self.qualifiedDrivers.list[0].id
      if (!self.runValidate) {
        self.mapLoader = {
          show: false,
          label: ''
        }
        self.getDriverDetails(driverId)
        return
      }
      self.$sdk.get(`/reservation/${self.rsvpInMap.id}/validate`, {
        token: self.$store.state.session.sessionToken,
        providerId: driverId
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/reduceQualifiedDrivers')

          let driver = ''
          if (data.unfiltered) driver = data.unfiltered.find(d => d.id == driverId)
          self.$store.commit('global/addReasonList', {
            id: driverId,
            name: driver ? driver.name : '',
            reason: r.error.message
          })

          // if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          if (!self.qualifiedDrivers.list.length) self.noQueueDrivers(false)
          else self.validateQualifiedDrivers(data)
          // self.getDriverDetails(driverId, true)
          return
        }

        self.getDriverDetails(driverId)
      }, '2.0')
    },
    getDriverDetails (id, showOnly = false) {
      let self = this

      self.$sdk.get(`/provider/${id}`, {
        token: self.$store.state.session.sessionToken,
      }, r => {
        if (r.error) {
          if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          else if (!showOnly) self.validateQualifiedDrivers()
          return
        }
        // Remove info bubble
        self.hereMaps.ui.getBubbles().forEach(bub => {
          self.hereMaps.ui.removeBubble(bub)
        })
        // Remove current drivers
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('nearbyDrivers') > -1) {
            self.hereMaps.map.removeObject(object)
          }
        }
        self.$store.commit('dispatch/setDriversNearRsvp', [
          {
            id: id,
            phone: `${r.countryCode }${r.phone}`,
            firstName: r.firstName,
            lastName: r.lastName,
            photoUrl: r.avatarUrl,
            coords: {
              lat: self.qualifiedDrivers.list[0].home.lat,
              lng: self.qualifiedDrivers.list[0].home.lng,
            },
            vehicle: {
              name: `${r.vehicle.manufacturer} ${r.vehicle.model}`,
              licensePlate: r.vehicle.licensePlate,
              photoUrl: r.vehicle.photo
            },
            isQualified: true
          }
        ])
        self.mapLoader = {
          show: false,
          label: ''
        }
        self.$store.commit('dispatch/reduceQualifiedDrivers')
        self.driverPresentation = true
        if (self.delayBeginDriverPresentation) {
          clearTimeout(self.delayBeginDriverPresentation)
        }
        self.delayBeginDriverPresentation = setTimeout(function () {
          self.beginDriverPresentation(true)
        }, 400)
        self.setDriverPin(showOnly)
        self.driverPresented = []
        self.setCenter()
        // self.getUpcomingRes(id) // Show upcoming res
      })
    },
    getUpcomingRes (id) {
      let self = this
      let pageSize = 5
      let page = 1
      let pickupSince = moment()
      let pickupUntil = moment().add(1, 'days')
      self.upcoming.loading = true
      self.upcoming.rsvp = null

      self.$sdk.get(`/provider/${id}/rsvp/upcoming`, {
        token: self.$store.state.session.sessionToken,
        pageSize: pageSize,
        pageNum: page,
        pickupSince: pickupSince.format('YYYY-MM-DD'),
        pickupUntil: pickupUntil.format('YYYY-MM-DD')
      }, r => {
        self.upcoming.loading = false
        if (r.error) { return }

        if (r.list.length <= 0) { return }
        self.upcoming.rsvp = r.list[0]
        self.displayDriverInfo(self.nearbyDrivers[0], 1)
      })
    },
    noQualifiedDrivers () {
      this.mapLoader = {
        show: false,
        label: ''
      }
      // this.$store.commit('global/setAlertData', {
      //   show: true,
      //   message: 'No nearby drivers found.'
      // })
      this.queueError = {
        show: true,
        message: `No ${this.lastDriverType} drivers found.`,
      }
    },
    noQueueDrivers (r = false) {
      this.mapLoader = {
        show: false,
        label: ''
      }
      this.queueError = {
        show: true,
        message: 'No qualified drivers found.'
      }
      if (r) this.buildReasons(r)
    },
    buildReasons (r) {
      let list = []
      for (const key of Object.keys(r.unqualified)) {
        if (r.unqualified[key][0] === 'services') continue
        let driver = r.unfiltered.find(d => d.id == key)
        if (driver) {
          list.push({
            id: driver.id,
            name: driver.name,
            reason: r.unqualified[key][0]
          })
        }
      }
      this.$store.commit('global/setReasonsData', {list: list})
    },
    showReasons () {
      this.queueError.show = false
      this.$store.commit('global/setReasonsData', {
        reasonsModal: true
      })
    }
  },
  watch: {
    rsvpInMap (value) {
      let self = this
      self.driverInfoIndex = 0
      self.driverDistance = []
      self.$store.commit('dispatch/removeAllDriversInMap')
      self.mapPins = []
      self.current = {
        driversInMap: [],
        nearbyDrivers: [],
        openDriver: ''
      },
      self.driverPresented = []

      // remove pins and info window
      for (let object of self.hereMaps.map.getObjects()) {
        self.hereMaps.map.removeObject(object);
      }
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })

      if (value.id === null) {
        self.rsvp = null
        self.route.rsvp = []
        self.waiting.renderDriver.data = null
        self.$store.commit('dispatch/clearDriverPopup')
        return
      }
      self.rsvp = value
      self.driverFilter = {
        show: false,
        isLoading: false,
        miles: 10,
        serviceTypes: [ value.serviceClass ]
      }

      if (value.isPackage) {
        value.route.forEach((loc, index) =>{
          value.route[index].packageID = value.id
        })
        self.setMapPins(value.route)
      } else {
        let pickup = value.pickup
        pickup.isPickup = true
        let dropoff = value.dropoff
        dropoff.isPickup = false
        self.setMapPins([pickup, dropoff])
      }

      if (value.hasExtraStop) {
        self.getExtraStops(value.id)
      }

      if (value.driver !== null) {
        let getDriverLocation =  true
        if (value.isPackage) {
          let rsvp = ''
          value.route.every((stop, index) => {
            rsvp = value.rsvps.find(x => x.id === stop.rsvpID && ['ontheway', 'arrived', 'onboard'].indexOf(x.rsvpStatus) > -1)
            return !rsvp ? true : false
          })
          if (rsvp) {
            getDriverLocation = false
          }
        }
        
        if (getDriverLocation){
          ApiDispatchDrivers.getDriverInfo(self, value.driver.id, driver => {
            if (driver.error) { return }
            self.updateDriverLocation(driver, true)
          })
        }
      }
    },
    driversInMap (value) {
      let self = this
      self.setDriverPin()
    },
    _rsvpInMapPickup (value) {
      let self = this
      if (value) {
        if (this.waiting.renderDriver.process && this.waiting.renderDriver.data) {
          this.waiting.renderDriver.process = false
          let driver = this.waiting.renderDriver.data
          this.driverDistance.push({
            id: driver.ID,
            distance: self.calculateDistance(
              {lat: driver.tracks.lat, lng: driver.tracks.lng},
              {lat: value.lat, lng: value.lng}
            )
          })
        }
      }
    },
    driverDistance (value) {
      if (value && this.waiting.beginDriverPresentation) {
        this.waiting.beginDriverPresentation = false
      }
    },
    driverPopupRoute (value) {
      if (value && value.id) {
        let self = this
        let pageSize = 5
        let page = 1
        let pickupSince = moment()
        let pickupUntil = moment().add(1, 'days')
        self.upcoming.loading = true
        self.upcoming.rsvp = null

        self.$sdk.get('/provider/' + value.id + '/rsvp/upcoming', {
          token: self.$store.state.session.sessionToken,
          pageSize: pageSize,
          pageNum: page,
          pickupSince: pickupSince.format('YYYY-MM-DD'),
          pickupUntil: pickupUntil.format('YYYY-MM-DD')
        }, r => {
          self.upcoming.loading = false
          if (r.error) { return }

          if (r.list.length <= 0) { return }
          self.upcoming.rsvp = r.list[0]
        })
        return
      }
    },
    'upcoming.rsvp': function (value) {
      let self = this
      self.hereMaps.ui.getBubbles().forEach(bub => {
        // console.log('bub', bub)
      })
    },
    'driverFilter.show': function (val) {
      if (val) {
        this.filterServices()
      }
    }
  },
  mounted () {
    let self = this
    let rsvpInMap = self.$store.state.dispatch.rsvpInMap
    if (rsvpInMap.id) {
      self.rsvp = self.$store.state.dispatch.rsvpInMap
      self.mapPins = [rsvpInMap.pickup, rsvpInMap.dropoff]
      // self.routeRsvp()
    }

    let mapContainer = document.getElementById('mapHere')
    self.hereMaps.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})

    let defaultLayers = self.hereMaps.platform.createDefaultLayers()
    self.hereMaps.map = new window.H.Map(mapContainer,
      defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
      }
    )

    /* eslint-disable no-unused-vars */
    let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)
  }
}
</script>

<style lang="scss" scoped>
.dispatch-map{
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
}
.map-here{
  position: absolute;
  width: 100%;
  height: 100%;
}

.map-loader{
  position: absolute;
  left: calc(50% - 125px);
  top: 20px;
  z-index: 2;
  background-color: #F25E0D;
  border-radius: 3px;
  padding: 5px 10px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  transition: all 250ms;
  opacity: 1;
  width: 250px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);

  &.hide {
    opacity: 0;
    top: -50px
  }
}

.driver-filters{
  position: absolute;
  top: 0;
  left: 0;
  width: 350px;
  height: auto;
  z-index: 4;
  background-color: #F4F8F9;
  border-bottom-right-radius: 3px;
  overflow: hidden;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.35);
  transition: all 250ms;

  &.hide{ top: -150%; }

  & .message{
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    padding: 14px 14px 14px 46px;
    background-color: #0D79F2;
    color: #fff;
  }

  & .radius-input {
    padding: 10px 15px;
    display: flex;
    align-items: center!important;

    & > * {
      vertical-align: middle;
    }
    & label {
      font-size: 13px;
      color: #8DA0A9;
      font-weight: 700;
      width: 100%;
    }

    & input {
      display: inline-block;
      width: 100px;
      padding: 12px 10px 11px;
      margin-top: 0;
      margin-right: 8px;
      border: 1px solid rgba(0,0,0,0.3);
    }
  }

  & .service-types {
    padding: 0px 15px;
    margin-bottom: 10px;

    .row{ padding-left: 25px; }
    & .title{
      font-size: 12px;
      color: #8DA0A9;
      font-weight: 700;
    }
    & label{
      & > * {
        display: inline-block;
        vertical-align: middle;
      }

      & input{
        width: auto;
        margin-top: 0;
      }

      & span{
        font-weight: 700;
        color: #777;
        margin-left: 5px;
      }
    }
  }

  & .divider{
    width: 80%;
    border-top: 1px solid rgba(0,0,0,0.2);
    margin: 15px auto;
  }

  & .button-wrapper{
    padding: 0 15px 15px;
  }

  .filter-note{
    padding: 10px;
    font-size: 14px;
    color: #93881e;
    background: #fff9c5;
    border: 1px solid #ccbd2f;
    border-radius: 4px;
    margin: 10px 20px 0;
    box-shadow: 1px 1px 2px rgba(0,0,0, .1);
  }
}

.cover{
  position: absolute;
  top: -500px; left: 0;
  width: 100%;
  // height: 100%;
  background-color: rgba(13, 121, 242, 0.8);
  z-index: 5;
  transition: all 250ms;

  &.show{
    top: 0;
  }

  & .cover-container{
    display: table;
    width: 100%;
    height: 100%;
  }

  & .cover-content {
    padding: 15px;
    font-weight: 700;
    color: #FFF;
    display: table-cell;
    vertical-align: middle;
    text-align: center;

    & .content{
      margin-top: 10px;
    }
  }
}

.filter-toggle{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #F4F8F9;
  color: #555;
  padding: 9px 10px 8px;
  border-bottom-right-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  transition: all 250ms;

  & i { line-height: inherit; }

  &.open {
    box-shadow: 0 2px 4px rgba(0,0,0,0);
    background-color: #0D79F2;
    color: #fff;
  }

  &.hide{
    top: -50px;
  }
}

.recenter {
  position: absolute;
  bottom: 30px;
  left: 30px;
  height: 45px;
  width: 45px;
  text-align: center;
  line-height: 46px;
  color: #777;
  background-color: #fff;
  box-shadow: 0 0 8px rgba(0,0,0,0.3);
  border-radius: 50%;
  z-index: 2;

  & i { line-height: inherit; }
}

.search-status {
  position: absolute;
  top: 20px;
  left: calc(50% - 175px);
  width: 350px;
  background-color: #26D97A;
  color: #fff;
  text-align: center;
  font-size: 14px;
  padding: 5px 10px;
  font-weight: 700;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  border-bottom: 1px solid rgba(0,0,0,0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 250ms;

  &.hide {
    top: -50px;
  }
}

@media only screen and (max-width: 430px) {
  .map-here {
    height: 50%;
  }
  .cover {
    top: auto;
    bottom: -500px;
    &.show{
      bottom: 0;
    }
  }
  .driver-filters {
    width: 100%;
    bottom: 0;
    top: auto;

    &.hide {
      top: auto;
    }

    .service-types {
      height: calc(50vh - 200px);
      overflow-x: scroll;
    }
  }
}

.dispatch-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }

  .option{
    display: block;
    width: 300px;
    margin:0 auto;
    text-align: left;

    input[type=radio]{
      width: auto;
      display: inline-block;
      margin-right: 5px;
      margin-top: 0;
    }
    span.s{
      display: inline-block;
      font-size: 14px;
      color: #444;
    }
  }
}

.dispatch-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.dispatch-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
}

.validation-modal {
  & .title{
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background-color: #F25E0D;
    padding: 8px 15px;
  }

  & .message{
    font-size: 16px;
    font-weight: 700;
    color: #555;
    padding: 15px 15px 10px;
  }

  & .button{
    font-weight: 700;
  }
  .cancel{
    margin-top: 10px;
    color: #999;
    display: inline-block;
  }
}

.action-modal{
  padding: 15px;
  & .message{
    font-weight: 700;
    color: #777;
    transition: all 250ms;

    &.success{ color: #26D97A; }
    &.error{ color: #F20D0D; }
  }
}

// Define vars we'll be using
$brand-success: #26D97A;
$loader-size: 50px;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12);
$error-left: $loader-size/4;
$check-thickness: 5px;
$check-color: $brand-success;
$error-color: #F20D0D;

.circle-loader {
  margin: 0 0 10px 10px;
  border: $check-thickness solid rgba(0, 0, 0, 0.2);
  border-left-color: $check-color;
  animation-name: loader-spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  box-sizing: content-box;
}

.circle-loader,
.circle-loader:after {
  border-radius: 50%;
  width: $loader-size;
  height: $loader-size;
}

.load-complete {
  -webkit-animation: none;
  animation: none;
  border-color: $check-color;
  transition: border 500ms ease-out;
}
.load-error {
  -webkit-animation: none;
  animation: none;
  border-color: $error-color;
  transition: border 500ms ease-out;
}

.checkmark {
  opacity: 0;
  box-sizing: content-box;
  &.draw{ opacity: 1; }
  &.draw:after {
    opacity: 1;
    height: $check-height;
    width: $check-width;
    transform-origin: left top;
    border-right: $check-thickness solid $check-color;
    border-top: $check-thickness solid $check-color;
    content: '';
    left: calc(#{$check-left} - 5px);
    top: calc(#{$check-height} + 2px);
    position: absolute;
    animation-duration: 1.2s;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }
  
  &.error {
    position: absolute;
    left: calc(#{$error-left} - 2px);
    top: $error-left;
    width: $loader-size/2;
    height: $loader-size/2;
    opacity: 0;
    &.show{ opacity: 1; }
    &:before, &:after {
      position: absolute;
      content: ' ';
      height: $loader-size/2;
      width: 5px;
      background-color: #f00;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

}
@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
}
.input-integer > * {
  display: inline-block;
  vertical-align: middle;
  margin-top: 5px;
}
input[type="number"] {
  font-size: 14px;
  padding: 7px 10px;
  display: inline-block;
  width: 200px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-integer span {
  font-size: 12px;
  background-color: #555;
  color: #fff;
  padding: 9px 10px 10px;
  margin-left: -5px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  min-width: 300px;
  max-width: 500px;
}
.lr-alert-msg{
  margin-bottom: 20px;
  color: #45505b;
}
.show-reasons-btn{
  margin-top: 12px;
  font-size: 14px;
  color: #838689;
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/Map2.vue